import { render, staticRenderFns } from "./AdvancedForms.vue?vue&type=template&id=35bca61e"
import script from "./AdvancedForms.vue?vue&type=script&lang=js"
export * from "./AdvancedForms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports